import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "no-tabs sent-geo-modal user-form" }
const _hoisted_2 = { class: "row justify-content-center" }
const _hoisted_3 = { class: "col-md-6" }
const _hoisted_4 = {
  key: 0,
  class: "edit"
}
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "invalid-feedback" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-md-6 mb-3" }
const _hoisted_10 = { class: "form-label" }
const _hoisted_11 = { class: "invalid-feedback" }
const _hoisted_12 = { class: "col-md-6 mb-3" }
const _hoisted_13 = { class: "form-label" }
const _hoisted_14 = { class: "invalid-feedback" }
const _hoisted_15 = { class: "mb-3" }
const _hoisted_16 = { class: "form-label" }
const _hoisted_17 = { class: "mb-3" }
const _hoisted_18 = { class: "form-label" }
const _hoisted_19 = { class: "mb-3" }
const _hoisted_20 = { class: "form-label" }
const _hoisted_21 = { class: "form-check mb-3" }
const _hoisted_22 = {
  class: "form-check-label",
  for: "activeCheck"
}
const _hoisted_23 = { class: "mb-3" }
const _hoisted_24 = { class: "form-label" }
const _hoisted_25 = { class: "invalid-feedback d-block" }
const _hoisted_26 = { class: "text-muted" }
const _hoisted_27 = { class: "mb-3" }
const _hoisted_28 = { class: "form-label" }
const _hoisted_29 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_30 = ["placeholder"]
const _hoisted_31 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_32 = {
  type: "submit",
  class: "btn btn-primary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueSelect = _resolveComponent("VueSelect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      autocomplete: "off",
      onSubmit: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", null, [
            (_ctx.isEdit)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$t('modules.users.edit_head')), 1))
              : _createCommentVNode("", true),
            (_ctx.isEdit)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(_ctx.model.name) + " " + _toDisplayString(_ctx.model.surname), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createTextVNode(_toDisplayString(_ctx.$t('modules.users.new_head')), 1)
                ], 64))
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[14] || (_cache[14] = _createElementVNode("label", { class: "form-label" }, [
              _createTextVNode("E-mail "),
              _createElementVNode("span", { class: "text-danger" }, "*")
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.email) = $event)),
              disabled: _ctx.isEdit,
              type: "email",
              class: _normalizeClass(["form-control", { 'is-invalid': _ctx.v.model.email.$error }]),
              autocomplete: "off",
              onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.v.model.email.$touch()))
            }, null, 42, _hoisted_6), [
              [_vModelText, _ctx.model.email]
            ]),
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.emailError), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('modules.users.name')) + " *", 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model.name) = $event)),
                type: "text",
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.v.model.name.$error }]),
                autocomplete: "off",
                onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.v.model.name.$touch()))
              }, null, 34), [
                [_vModelText, _ctx.model.name]
              ]),
              _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.nameError), 1)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('modules.users.surname')) + " *", 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.model.surname) = $event)),
                type: "text",
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.v.model.surname.$error }]),
                autocomplete: "off",
                onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.v.model.surname.$touch()))
              }, null, 34), [
                [_vModelText, _ctx.model.surname]
              ]),
              _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.surnameError), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('modules.users.phone')), 1),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.model.phone) = $event)),
              type: "text",
              class: "form-control",
              autocomplete: "off"
            }, null, 512), [
              [_vModelText, _ctx.model.phone]
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('modules.users.driver_card')), 1),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.model.driver_card) = $event)),
              type: "text",
              class: "form-control",
              autocomplete: "off"
            }, null, 512), [
              [_vModelText, _ctx.model.driver_card]
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('modules.users.driver_card_validity')), 1),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.model.driver_card_validity) = $event)),
              type: "date",
              class: "form-control"
            }, null, 512), [
              [_vModelText, _ctx.model.driver_card_validity]
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.model.active) = $event)),
              class: "form-check-input",
              type: "checkbox",
              id: "activeCheck"
            }, null, 512), [
              [_vModelCheckbox, _ctx.model.active]
            ]),
            _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t('modules.users.active')), 1)
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t('modules.users.roles')) + " *", 1),
            (_openBlock(), _createBlock(_component_VueSelect, {
              key: _ctx.model.roles.join('|'),
              options: _ctx.availableRoles,
              multiple: true,
              label: "label",
              icon: "bi bi-shield-lock",
              class: "vue-select flex-grow",
              onUpdateSelect: _ctx.onRolesSelect,
              onBlur: _cache[10] || (_cache[10] = ($event: any) => (_ctx.v.model.roles.$touch())),
              value: _ctx.selectedRoleOptions
            }, null, 8, ["options", "onUpdateSelect", "value"])),
            _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.rolesError), 1),
            _createElementVNode("small", _hoisted_26, _toDisplayString(_ctx.$t('modules.users.roles_hint')), 1)
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("label", _hoisted_28, [
              _createTextVNode(_toDisplayString(_ctx.$t('modules.users.password')) + " ", 1),
              (!_ctx.isEdit)
                ? (_openBlock(), _createElementBlock("span", _hoisted_29, "*"))
                : _createCommentVNode("", true)
            ]),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.newPassword) = $event)),
              type: "password",
              name: "new-password",
              autocomplete: "new-password",
              class: _normalizeClass(["form-control", { 'is-invalid': _ctx.passwordError }]),
              onBlur: _cache[12] || (_cache[12] = ($event: any) => (_ctx.v.newPassword.$touch())),
              placeholder: _ctx.isEdit ? _ctx.$t('modules.users.password_hint') : ''
            }, null, 42, _hoisted_30), [
              [_vModelText, _ctx.newPassword]
            ]),
            (_ctx.passwordError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(_ctx.passwordError), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("button", _hoisted_32, _toDisplayString(_ctx.$t('modules.users.save')), 1)
        ])
      ])
    ], 32)
  ]))
}